<template>
  <v-dialog v-model="internalDialogVisible"
            width="600px">
    <v-card>
      <v-card-title class="headline">Delete this user? <v-spacer /><v-btn icon @click="close()"><v-icon>clear</v-icon></v-btn></v-card-title>
      <v-card-text>
        <v-container>
          <v-row style="font-weight: bold;">User to be deleted:</v-row>
          <v-row>First and Last Name: <span style="font-weight: bold"> {{ firstName }} {{ lastName }}</span></v-row>
          <v-row>User Email: <span style="font-weight: bold"> {{ email }}</span></v-row>
          <v-row>Online Username: <span style="font-weight: bold"> {{ username }}</span></v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="pl-5">
        <v-btn depressed tile color="#004C97" class="text-uppercase white--text" @click="confirm()">Yes, delete user</v-btn>
        <v-btn depressed tile @click="close()">Cancel</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'RemoteAgencyCurrentUserDeleteDialog',
  props: {
    showCurrentDeleteUserDialog: Boolean,
    firstName: { required: true, type: String },
    lastName: { required: true, type: String },
    email: { type: String, default: '' },
    username: { type: String, default: '' }
  },
  computed: {
    internalDialogVisible: {
      get: function () {
        return this.showCurrentDeleteUserDialog;
      },
      set: function (visible) {
        if (!visible) {
          this.$emit('close');
        }
      }
    }
  },
  methods: {
    close: function () {
      this.internalDialogVisible = false;
    },
    async confirm () {
      this.$emit('success');
      this.close();
    }
  }
};
</script>

<style scoped>

</style>
